import { ChangeDetectorRef, Component, ElementRef, Input, NgZone, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef, ViewRef } from '@angular/core';
import { UiService } from '../../services/ui.service';
import { Globals } from '../../globals';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MessagingService } from '../../services/messaging.service';
import { CommMethodEnum } from '../../models/enum/comm-method.enum';
import moment from 'moment';
import { LOCID } from '../../constants';
import { PatientDialogDataModel } from '../../modules/patient/patient-dialog-data.model';
import { PatientEditComponent } from '../../modules/patient/patient-edit/patient-edit.component';
import { fromEvent, interval, Subscription } from 'rxjs';
import { NotificationService } from '../../services/messaging/notification.service';
import { PatientService } from '../../modules/patient/patient.service';
import { PatientSearchModel } from '../../models/patient/patient-search.model';
import { MessagingConstants } from '../../models/MessagingConstants';
import { FileManagerService } from '../../modules/file-manager/file-manager.service';
import { SignalrService } from '../../services/socket/signalr.service';
import { AuthenticationService } from '../../modules/auth/services/authentication.service';
import { UserRoleEnum } from '../../models/enum/user-role.enum';
import { TdoPatientSearchComponent } from '../../tdo-controls/tdo-patient-search/tdo-patient-search.component';
import { dataPatientCaseWorkItem } from '../../modules/ar/_models/ar.models';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take } from 'rxjs/operators';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { SecureImagePipe } from 'src/app/pipes/secure-image.pipe';
import { DOCUMENT_TAG } from 'src/app/models/constants/document-tag.model';
import { DocumentDataModel } from 'src/app/models/document/document-data.model';
import { Router } from '@angular/router';
import { DialogService } from 'src/app/services/dialog.service';
import { version } from 'src/environments/version';
import { ConfirmComponent } from 'src/app/dialog/confirm-dialog/confirm.component';


@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild('tps') patientInputSearch: TdoPatientSearchComponent;
  @ViewChild('pasteMenu') pasteMenu: TemplateRef<any>;

  isTopExpanded: boolean = true;
  isShowPatientSearch = false;
  moment = moment;

  searchString: string = '';

  refreshingImages: boolean = false;
  locid: number = 0;

  currentPatient: any;
  currentPatientDoctors: any;
  patientBirthday: moment.Moment;
  patientAddress: string = '';
  patientPhoneNum: string = '';
  patientDifficultyEnum: string = '';

  isPrivateInfoVisible: boolean = false;
  patientSearchList: PatientSearchModel[] = [];

  isActionCheckOut: boolean = false;

  private msgSub: Subscription;
  private messageUpdateSub: Subscription;
  patientPictureSrc: string = 'assets/Images/defaultPatient.PNG';
  isContextOpen = false;
  private overlayRef: OverlayRef | null;
  private sub: Subscription;
  private signalrSub: Subscription;
  currentPatientCaseId: string;

  constructor(public uiService: UiService, 
    public globals: Globals, 
    private readonly dialog: MatDialog,
    private readonly signalrService: SignalrService,
    private readonly fileService: FileManagerService,
    private readonly messagingService: MessagingService,
    private readonly dialogService: DialogService,
    private readonly authenticationService: AuthenticationService,
    private readonly patientService: PatientService,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly overlay: Overlay,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly ngZone: NgZone,
    private readonly notificationService: NotificationService) { }
  private privacyMonitorSubscription: Subscription;

  private readonly onPatientPictureStorage = (e: StorageEvent): void => {
    if (e.key !== MessagingConstants.LOCAL_STORAGE_PATIENT_PICTURE_REFRESH || !e.newValue) return;
    try {
      const data = JSON.parse(e.newValue) as { patientId?: string };
      if (data.patientId && data.patientId === this.globals.currentPatientId) {
        this.ngZone.run(() => this.refreshPatientPicture());
      }
    } catch { /* ignore */ }
  };

  private refreshPatientPicture(): void {
    this.fileService.getPatientPictureClearCache(this.globals.currentPatientId).subscribe(() => {
      this.fileService.getPatientPicture(this.globals.currentPatientId + '?' + new Date().toString()).subscribe((res) => {
        this.patientPictureSrc = res ? this.fileService.getDocumentUrlFromDocument(res) : 'assets/Images/defaultPatient.PNG';
        if (!(this.cdr as ViewRef).destroyed) {
          this.cdr.detectChanges();
        }
      });
    });
  }

  ngOnInit(): void {
    this.messageUpdateSub = this.notificationService.messageUpdate.subscribe(() => {
      this.cdr.detectChanges();
    });
    if (localStorage.getItem('LoadedVersion') != version) {
      console.log('app version mismatch, reloading...');
      localStorage.setItem('LoadedVersion', version);
      localStorage.setItem('LoadedVersionDate', new Date().toLocaleString());
      const whatsNew = localStorage.getItem('WhatsNew') || '';
      if (whatsNew !== '') {
        const dialogRef = this.dialog.open(ConfirmComponent, {
          width: '800px',
          data: {
            title: `What's new in TDOS version V${version}`,
            message: whatsNew,
            isShowCancel: false,
            isShowNo: false,
            width: '800px',
          },
        });


        dialogRef.afterClosed().subscribe(() => {
          globalThis.location.href = globalThis.location.href + '?t=' + Date.now();
        }, (err: any) => {
          console.error(err);
        });
      }
      else
      {
        globalThis.location.href = globalThis.location.href + '?t=' + Date.now();
      }
      return;
    }
    if (localStorage.getItem(LOCID)) {
      this.locid = Number.parseInt(localStorage.getItem(LOCID));
    }

    if (this.globals.ThePatient === null || this.globals.ThePatient === undefined) {
      this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
        PatientID: this.globals.currentPatientId,
        clearCurrentQuery: true,
      });
    }

    this.globals.PrivacyEnabled = !this.isPrivateInfoVisible;
    this.setupPrivacyMonitoring();
    this.initPatient(this.globals.ThePatient);
    // console.log('HomeComponent currentPatientCaseId: ', this.globals.currentPatientCaseId);
    this.currentPatientCaseId = this.globals.currentPatientCaseId;
    // console.log('HomeComponent currentPatientCaseId: ', this.currentPatientCaseId);

    this.msgSub = this.messagingService.componentMessageCall.subscribe(response => {
      if (response.event === MessagingConstants.PATIENT_LOADED) {
        // console.log('HomeComponent PATIENT_LOADED: ', this.globals.ThePatient);
        this.initPatient(this.globals.ThePatient);
      }
      else if (response.event === (MessagingConstants.HEADER_MINIMIZE)) {
        this.isTopExpanded = false;
      }
      else if (response.event === MessagingConstants.CASE_CHANGED_EVENT) {
        // console.log('HomeComponent CASE_CHANGED_EVENT response: ', response);
        // console.log('HomeComponent CASE_CHANGED_EVENT globals.currentPatientCaseId: ', this.globals.currentPatientCaseId);
        // console.log('HomeComponent CASE_CHANGED_EVENT this.currentPatientCaseId: ', this.currentPatientCaseId);
        this.currentPatientCaseId = this.globals.currentPatientCaseId;
      }
    });

    this.signalrSub = this.signalrService.messageUser.subscribe((res) => {
      if (res.messageType === SignalrService.UPDATE_PROFILE) {
        if (res.message && res.message['patientId'] && res.message['patientId'] === this.globals.currentPatientId) {
          this.initPatient(this.globals.ThePatient);
        }
      }
      else if (res.messageType === 'UPDATE_PATIENT_PICTURE') {
        if (res.message && res.message['patientId'] && res.message['patientId'] === this.globals.currentPatientId) {
          this.refreshPatientPicture();
        }
      }
    });

    if (typeof window !== 'undefined') {
      window.addEventListener('storage', this.onPatientPictureStorage);
    }
  }

  ngOnDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('storage', this.onPatientPictureStorage);
    }

    if (this.messageUpdateSub)
      this.messageUpdateSub.unsubscribe();

    if (this.msgSub)
      this.msgSub.unsubscribe();

    if (this.signalrSub)
      this.signalrSub.unsubscribe();

    if (this.privacyMonitorSubscription)
      this.privacyMonitorSubscription.unsubscribe();
  }

  onDifficultySelectionChange(event) {
  }

  onProfileClick() {
    this.openEditPatient();
  }



  openEditPatient() {
    const dm = new PatientDialogDataModel();
    dm.title = 'Edit Patient';
    dm.mode = PatientDialogDataModel.MODE_EDIT_PATIENT;
    dm.entityId = this.globals.currentPatientId;

    const config = new MatDialogConfig();
    config.width = '968px';
    config.height = '600px';
    config.data = dm;
    //config.panelClass = 'tdo-note-dialog-main';
    config.panelClass = 'patient-edit-dialog';


    const dialogRef = this.dialog.open(PatientEditComponent, config);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.patientDeleted) {
          // Patient was deleted, refresh the page to clear patient data
          this.router.navigate(['/']);
          return;
        }

        this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
          PatientID: this.globals.currentPatientId,
          clearCurrentQuery: false,
        });

        this.initPatient(result);
      }
    }, err => {
      console.error(err);
    });
  }

  onAddPatientClick() {
    const dm = new PatientDialogDataModel();
    dm.mode = PatientDialogDataModel.MODE_NEW_PATIENT;
    dm.title = 'New Patient';
    //dm.initWebId = true;
    dm.entityType = PatientDialogDataModel.TYPE_PATIENT;

    const config = new MatDialogConfig();
    config.width = '968px';
    config.height = '600px';
    config.panelClass = 'tdo-note-dialog-main';
    config.data = dm;

    const dialogRef = this.dialog.open(PatientEditComponent, config);

    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.globals.currentPatientSelectedCaseItem = undefined;
        this.globals.save();

        this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
          PatientID: result.ThePatient.PatientId,
          clearCurrentQuery: false,
        });
        this.messagingService.sendComponentMessage('START-REASON-FOR-VISIT', '');
      }
    }, err => {
      console.error(err);
    });

  }

  getDifficultyLevel() {
    switch (this.patientDifficultyEnum) {
      case '00000000-0000-0000-0000-000000000000':
        return 'N/A';
      case '00000107-1000-0000-0000-000000000001':
        return 'T1';
      case '00000107-1000-0000-0000-000000000002':
        return 'T2';
      case '00000107-1000-0000-0000-000000000003':
        return 'T3';
      default:
        return 'N/A';
    }
  }

  onPrivacyClick() {
    this.isPrivateInfoVisible = !this.isPrivateInfoVisible;
    this.globals.PrivacyEnabled = !this.isPrivateInfoVisible;
    // Hide content in 30 minutes
    if (this.isPrivateInfoVisible) {
      setTimeout(() => {
        this.isPrivateInfoVisible = false;
        this.globals.PrivacyEnabled = !this.isPrivateInfoVisible;
      }, 1800000);
    }
  }

  async getPatientPicture(PatientId: string) {
    let url = 'assets/Images/defaultPatient.PNG';
    if (PatientId !== 'null' && PatientId !== 'undefined' && PatientId !== null && PatientId !== undefined) {
      //this.fileService.getPatientPictureClearCache(PatientId).toPromise();
      const res: DocumentDataModel = await this.fileService.getPatientPicture(PatientId + '?' + new Date().toString()).toPromise();
      if (res) {
        url = this.fileService.getDocumentUrlFromDocument(res);
      }
    }
    return url;
  }

  private async initPatient(newPatient: any): Promise<void> {
    // Reset patient data if no patient is selected
    if (newPatient === null || newPatient === undefined) {
      this.patientPictureSrc = 'assets/Images/defaultPatient.PNG';
      this.currentPatient = null;
      this.patientBirthday = null;
      this.patientAddress = '';
      this.patientPhoneNum = '';
      this.patientDifficultyEnum = '';
      this.currentPatientDoctors = [];
      // Reset global patient data
      this.globals.currentPatientCaseWorkItemID = '';
      this.globals.currentPatientCaseWorkItem = new dataPatientCaseWorkItem();
      return;
    }

    if (newPatient.dataContact === null || newPatient.dataContact === undefined) {
      this.patientPictureSrc = 'assets/Images/defaultPatient.PNG';
      this.currentPatient = newPatient;
      this.patientBirthday = null;
      this.patientAddress = '';
      this.patientPhoneNum = '';
      this.patientDifficultyEnum = '';
      this.currentPatientDoctors = [];
      return;
    }

    // Check if a patient picture exists in the file system.
    if (this.globals.currentPatientId && newPatient && newPatient.patientImageUrl) {
      this.patientPictureSrc = newPatient?.patientImageUrl ? this.fileService.getDocumentImageUrl(this.globals.currentPatientId, newPatient?.patientImageUrl) : '/assets/Images/defaultPatient.PNG';
    } else {
      this.patientPictureSrc = await this.getPatientPicture(this.globals.currentPatientId);
    }

    // reset current case work item after logging in
    this.globals.currentPatientCaseWorkItemID = '';
    this.globals.currentPatientCaseWorkItem = new dataPatientCaseWorkItem();

    this.currentPatient = newPatient;
    this.patientBirthday = newPatient.BirthDate ? moment(newPatient.BirthDate) : null;

    const firstName: string = newPatient.dataContact.FirstName || '';
    const midName: string = newPatient.dataContact.MidName || '';
    const lastName: string = newPatient.dataContact.LastName || '';
    this.globals.currentPatientFullName = `${firstName} ${midName} ${lastName}`;
    this.globals.currentPatientNo = newPatient.PatientNO != null ? `${newPatient.PatientNO}` : '';
    this.globals.save();

    const address = newPatient.dataContact.dataAddresses[0];

    const hasAddr = address !== null && address !== undefined;
    this.patientAddress = 'No address';

    if (hasAddr) {
      this.patientAddress = '';
      if (address.Address1) { this.patientAddress += address.Address1; }
      if (address.Address2) { this.patientAddress += ` ${address.Address2}`; }
      if (address.City) { this.patientAddress += ` ${address.City}`; }
      if (address.State) { this.patientAddress += `, ${address.State}`; }
      if (address.PostCode) { this.patientAddress += ` ${address.PostCode}`; }
    }

    const phoneNums = newPatient.dataContact.dataContactComms
      .filter(o => o.enumCommMethodID === CommMethodEnum.Phone || o.enumCommMethodID === CommMethodEnum.Mobile);

    if (phoneNums.length > 0) {
      const preferredNum = phoneNums.find(o => o.isPreferred);

      if (preferredNum !== null && preferredNum !== undefined) {
        this.patientPhoneNum = preferredNum.Address;
      }
      else {
        this.patientPhoneNum = phoneNums[0].Address;
      }
    }
    else {
      this.patientPhoneNum = 'No phone number';
    }

    this.patientDifficultyEnum = this.currentPatient.enumPatientDifficultyLevelID;

    this.currentPatientDoctors = [];

    newPatient.dataPatientDoctors.forEach(patientDoctor => {
      if (patientDoctor.dataDoctorSpecialty && patientDoctor.dataDoctorSpecialty.dataDoctor && patientDoctor.dataDoctorSpecialty.dataDoctor.dataContact) {
        const dataDoctor = patientDoctor.dataDoctorSpecialty.dataDoctor;
        const dataDoctorContact = dataDoctor.dataContact;

        const doctorName = `Dr. ${dataDoctorContact.FirstName} ${dataDoctorContact.LastName}`;
        const isReferring = patientDoctor.isReferring;

        const obj = {
          name: doctorName,
          isReferring
        };

        this.currentPatientDoctors.push(obj);
      }
    });

    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }

  changeDifficultyLevel() {
    switch (this.patientDifficultyEnum) {
      case '00000000-0000-0000-0000-000000000000':
        this.patientDifficultyEnum = '00000107-1000-0000-0000-000000000001';
        break;
      case '00000107-1000-0000-0000-000000000001':
        this.patientDifficultyEnum = '00000107-1000-0000-0000-000000000002';
        break;
      case '00000107-1000-0000-0000-000000000002':
        this.patientDifficultyEnum = '00000107-1000-0000-0000-000000000003';
        break;
      case '00000107-1000-0000-0000-000000000003':
        this.patientDifficultyEnum = '00000000-0000-0000-0000-000000000000';
        break;
    }

    this.globals.ThePatient.enumPatientDifficultyLevelID = this.patientDifficultyEnum;
    this.patientService.saveDataPatient(this.globals.ThePatient).subscribe((resp) => {
      //
    });
  }

  onSearchPatientClick() {
    this.isShowPatientSearch = !this.isShowPatientSearch;
    setTimeout(() => {
      this.patientInputSearch.focus();
    }, 100);
  }

  closeSearch() {
    this.isShowPatientSearch = false;
    this.patientSearchList = [];
  }

  isUserHasRole(role: string) {
    switch (role) {
      case 'notes':
        return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.Notes) || this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.NotesViewOnly);
    }
  }
  checkedOutState() {
    this.isActionCheckOut = true;
  }
  onRightMouseClick(event: MouseEvent, title: string, type: string) {
    this.openContext(event, this.pasteMenu, null);
  }

  // Context menu
  // Context boilerplate
  openContext({ x, y }: MouseEvent, template: TemplateRef<any>, data: any, closeOnItemClick = true): void {
    this.isContextOpen = true;
    this.closeContext();
    x = x + 50;
    y = y - 20;
    const positionStrategy = this.overlay.position().flexibleConnectedTo({ x, y }).withPositions([
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top'
      }
    ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, { $implicit: data }));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          if (closeOnItemClick) {
            this.closeContext();
          } else {
            const clickTarget = event.target as HTMLElement;
            return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
          }
        }), take(1)).subscribe(() => this.closeContext());
  }

  closeContext(): void {
    this.sub !== undefined && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.isContextOpen = false;
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  onAcquire() {
    const tags: string[] = [];
    // Patient Picture tag
    tags.push(DOCUMENT_TAG.PatientPicture);
    localStorage.setItem('tags-imaging', JSON.stringify(tags));
    this.uiService.openAcquireDefaultDevice(tags);
  }

  /**
   * Displays patient name with masked last name
   * @param fullName - The full name of the patient
   * @returns First name with masked last name (e.g., "John D***")
   */
  displayPatientName(fullName: string): string {
    if (this.isPrivateInfoVisible) {
      return fullName;
    }
    if (!fullName || fullName.trim() === '') {
      return '';
    }

    const nameParts = fullName.trim().split(' ').filter(part => part.length > 0);

    if (nameParts.length === 0) {
      return '';
    }

    if (nameParts.length === 1) {
      // Only one name part, return as is
      return nameParts[0];
    }

    const firstName = nameParts[0];
    const lastName = nameParts[nameParts.length - 1];

    if (lastName.length <= 1) {
      // Last name is too short to mask
      return fullName;
    }

    const maskedLastName = lastName.charAt(0) + '*'.repeat(lastName.length - 1);

    // If there are middle names, include them
    if (nameParts.length > 2) {
      const middleNames = nameParts.slice(1, -1).join(' ');
      return `${firstName} ${middleNames} ${maskedLastName}`;
    }

    return `${firstName} ${maskedLastName}`;
  }

  setupPrivacyMonitoring() {
    // Monitor privacy setting changes every 500ms
    this.privacyMonitorSubscription = interval(500).subscribe(() => {
      const currentPrivacySetting = !this.isPrivateInfoVisible;
      const currentGlobalsSetting = this.globals.PrivacyEnabled;
      // If there's a mismatch, update the globals and trigger change detection
      if (currentPrivacySetting !== currentGlobalsSetting) {
        // Update the globals setting
        this.isPrivateInfoVisible = !currentGlobalsSetting;
        // Force change detection to update the UI
        //this.cd.detectChanges();
      }
    });
  }

}
